import { TireStatus } from 'app/shared/model/enumerations/tire-status.model';
import React from 'react';
import { Box, Chip } from '@mui/material';
import { renderStatus } from './tire-status';

interface Props {
  position?: number;
  steppe?: boolean;
}

export const TireImg = (props: Props) => {
  const { position, steppe } = props;
  return (
    <Box sx={{ textAlign: 'center' }}>
      <Box sx={{ position: 'relative', display: 'inline-block' }}>
        <Box
          component="img"
          sx={{ borderRadius: '0.6rem', display: 'block' }}
          src="../../../../content/images/load-measurement/tire.png"
          alt="Tire"
        />

        {position && (
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          >
            <Chip
              label={position}
              sx={{
                backgroundColor: 'common.white',
                color: 'common.black',
                borderRadius: '0.25rem',
                fontSize: '1rem',
                fontWeight: 600,
                width: 24,
                height: 24,
                '& .MuiChip-label': { px: 0, width: '100%', textAlign: 'center' },
              }}
            />
          </Box>
        )}
      </Box>

      {steppe && <Box>{renderStatus(TireStatus.STEPPE)}</Box>}
    </Box>
  );
};

export default TireImg;
